var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mit-my-borrowed-list pa-5"},[_c('BaseMitLoading',{attrs:{"show":_vm.loading,"overlayFullscreen":false}}),_c('BaseMitDataTable',{attrs:{"title":"Borrowed","editable":false,"headers":_vm.headers,"items":_vm.borrowed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }